import React from "react";
import { Link } from 'react-router-dom'; 

export default function NotFound() {
  return (
    <div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="main">
        <h1>404</h1>
        <p>
          It looks like you're lost...
          <br />
          That's a trouble?
        </p>
        
        <Link className="nav-link" to="/">
                Go Back
        </Link>
      </div>
    </div>
  );
}
